import axios from "axios";
import Spinner from "helpers/Spinner";
import { baseUrl,localUrl } from "@ora/recursos/src/helpers/Url";
import ModalCard from "layouts/mainsection/components/ModalCard";
import { nanoid } from "nanoid";
import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import helperStorage from "./helperStorage";
import { import_current_tab, import_set_data } from './store'

const styleFileLoaded = {
  fontSize: '2.5em'
}

class ImportarStep2 extends Component {
  state = {
    nameCurrentFile: 'Buscar',
    activeModalRecurso: false,
    selResource: -1,
    selSubLineaTem: -1,
    listResources: []
  }
  refSelResource = null
  constructor (props) {
    super(props)
    console.log('Constructo step2')
    this.refSelResource = createRef()
  }
  componentDidUpdate (props, state) {
    console.log('update import step 2', state, this.state)
    console.log('update import step 2', props, this.props)
    if (props.importData.typeInformation !== this.props.importData.typeInformation) {
      this.getResourceByTypeIOfformation(this.props.importData.typeInformation)
    }
    if (state.selResource !== this.state.selResource) {
      // this.getTableStructure(this.state.selResource)
    }
  }
  getResourceByTypeIOfformation =  (type_information_id) => {
    console.log('getResourceByTypeIOfformation')
    return axios.get(baseUrl(`aro/variable/${type_information_id}/recursos`)).then(res => {
      // this.props.import_setRecursos(res.data.success ? res.data.data : [])
      this.setState({
        listResources: res.data.success ? res.data.data : []
      })
      return res.data.data
    })
  }
  getTableStructure =  (resource_id) => {
    console.log('getResourceByTypeIOfformation')
    axios.get(baseUrl(`aro/variable/${resource_id}/recursos`)).then(res => {
      // this.props.import_setRecursos(res.data.success ? res.data.data : [])
      this.setState({
        listResources: res.data.success ? res.data.data : []
      })
    })
  }
  componentDidMount () {
    console.log('mounted step2', this.state, this.props)
    // this.props.import_set_data({resource: 999999})
    
  }
  disabledProcesar = () => {
    return +this.state.selResource !== -1
  }
  OnClick_openModal = () => {
    
    this.setState({
      activeModalRecurso: true
    })
  }
  onChange = (evt) => {
    const value = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
    
    if (evt.target.name === 'selResource') {
      this.setState({
        selResource: evt.target.value
      })
      this.props.import_set_data({
        resourceName: evt.target.selectedOptions[0].text,
        typeResource: evt.target.value
      })

    }
    if (evt.target.name === 'sub_linea_tematica') {
      this.setState({
        selSubLineaTem: evt.target.value
      })
    }
    if (evt.target.name === 'file-doc') {
        //change name curretn file
        let tn = 'Buscar'
        if (evt.target.files[0]) {
            tn = evt.target.files[0].name
        }
        this.setState({
            nameCurrentFile: tn
        })
    }

    this.setState({
      [evt.target.name]: value,
    });
  }
  textprueba = () => {
    // console.log(this.props)
    // console.log(this.state)
    return this.props.currentTab;
  }
  onSubmit_AddRecurso = event => {
    event.preventDefault()
    this.addRecurso()
  }
  addRecurso = () => {
    Spinner.show()
    let frm = document.getElementById('frmAddRecurso')
    let dfrm = new FormData(frm)
    dfrm.append('var_id', this.props.importData.typeInformation)
    axios.post(baseUrl('aro/resource?mode=basic'), dfrm).then(res => {
      
      if (res.data.success) {
        this.getResourceByTypeIOfformation(this.props.importData.typeInformation).then(data => {
          Spinner.hide()

          this.refSelResource.current.value = res.data.data
          this.setState({
            selResource: res.data.data
          })
          
          this.props.import_set_data({
            resourceName: data.find(ir => +ir.id === +res.data.data).name,
            typeResource: res.data.data
          })
          Swal.fire(
            'Recurso',
            res.data.message,
            'success'
          ).then(sr => {
            
          })
        })
        // alert(res.data.message)
        
        
      }
    }).catch(err => {
      Spinner.hide()
      Swal.fire(
        'Recurso',
        err.response,
        'error'
      ).then(sr => {
        
      })
    })
  }
  onSubmit_Step2 = (event) => {
    event.preventDefault()
    this.props.import_current_tab(3)

        // let sendData = this.state
        // let sendData = new FormData(document.getElementById('frmImportStep2'));
        // sendData.append('tempid', 'IDT' + nanoid(10).toString())
        // axios.post(baseUrl('cites/import/file?step=1'),sendData, {
        //   onUploadProgress: function(progressEvent) {
        //     var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        //     console.log(percentCompleted)
        //   }
        // }).then(res => {
        //   if (res.data.success) {
        //     this.props.import_current_tab(2)
        //     helperStorage.set({
        //       id: res.data.id,
        //       filename: res.data.filename,
        //       step: 1
        //     })
        //   }

          
        // })
  }
  CoptionRecursos = () => this.state.listResources.map((item, index) => <option key={index} value={ item.id }>{ item.name}</option>)

  render () {
    return (
      <div id={ this.props.id } className={this.props.className}>
        <form id="frmImportStep2" onSubmit={ this.onSubmit_Step2 }>
          <div className="field is-horizontal">
            <h2 className="title">Selección de Recurso</h2>
          </div>
          
          <div className="field is-horizontal">
            <ul>
              <li>              
                <label className="label">{this.props.importData.typeInformationName}</label>
              </li>
           </ul>

          </div>

          <hr />
          <div className="field center">
            <span style={styleFileLoaded} className="tag is-success"><span>{this.props.importData.fileName}</span></span>
          </div>
          <hr />
          <div className="field is-horizontal">
            <div className="field-label is-normal">
              <label className="label">Seleccione Recurso</label>
            </div>
            <div className="field-body">
              <div className="field">
                <div className="control">
                  <span className="select is-danger is-empty">
                    <select ref={ this.refSelResource } onChange={this.onChange} name="selResource" required="required">
                      <option value="-1">- Seleccionar -</option>
                      {this.CoptionRecursos()}
                    </select>

                  </span>

                </div>
                <button onClick={this.OnClick_openModal} className="button is-small is-primary mt-2" type="button">
                  <span className="icon"><i className="fas fa-plus"></i></span>&nbsp;&nbsp;Crear nuevo recurso
                </button>
                

              </div>
            </div>

          </div>
          <hr />
          <div className="field is-horizontal">

            <div className="field-body">
              <div className="field">

                <div className="field">

                  <div className="field-body is-pulled-right">
                    <div className="field is-grouped">

                      <div className="control">
                        <button type="submit" disabled={!this.disabledProcesar()} className="button is-primary">
                          <span>Procesar Archivo</span>
                        </button></div>

                    </div>
                  </div>

                </div>

              </div>
            </div>

          </div>

        </form>
        {<ModalCard 
          id="modalReg" 
          footer={true} 
          buttons={{success: 'Agregar', cancel: 'Cancelar'}}
          title="Agregar Recurso" active={this.state.activeModalRecurso} 
          onMSuccess={ res=> {
            console.log(this.state)
            console.log(res)
            if (this.state.selSubLineaTem !== -1) {
              this.addRecurso()
              res.close()
              this.setState({activeModalRecurso: false})
            } else {
              alert('Seleccionar Sub Línea Temática')
            }

          }}
          onMClose = {() => {
            this.setState({activeModalRecurso: false})
          }}
          onMCancel = {() => {
            this.setState({activeModalRecurso: false})
          }}
          >
          <form id="frmAddRecurso" onSubmit={ this.onSubmit_AddRecurso }>
            <div className="field is-horizontal columns is-gapless">
              <div className="column">
                <div className="field-label"><label className="label">Nombre</label></div>
              </div>
              <div className="field-body column  is-three-quarters">
                <div className="field">
                  <div className="control">
                    <input className="input form-control" name="name" type="text"  placeholder="" />
                  </div>

                </div>
              </div>

            </div>
            <div className="field is-horizontal columns is-gapless">
              <div className="column">
                <div className="field-label"><label className="label">Descripción</label></div>
              </div>
              <div className="field-body column  is-three-quarters">
                <div className="field">
                  <div className="control">
                    <input className="input form-control" name="descripcion" type="text"  placeholder="" />
                  </div>

                </div>
              </div>
            </div>
            <div className="field is-horizontal columns is-gapless">
            <div className="column">
              <div className="field-label">
                <label className="label">Seleccione Sub Linea Temática</label>
              </div>
            </div>
            <div className="field-body column is-three-quarters">
              <div className="field">
                <div className="control">
                  <span className="select is-danger is-empty">
                    <select onChange={this.onChange} name="sub_linea_tematica" required="required">
                      <option value="-1">- Seleccionar -</option>
                      {this.props.COptionLineaTematica}
                    </select>
                  </span>

                </div>
              </div>
            </div>
          </div>
            <div className="field is-horizontal columns is-gapless">
            <div className="column">
              <div className="field-label">
                <label className="label">Pais</label>
              </div>
            </div>
            <div className="field-body column is-three-quarters">
              <div className="field">
                <div className="control">
                  <span className="select is-danger is-empty">
                    <select onChange={this.onChange} name="sub_pais" required="required">
                      <option value="-1">- Seleccionar -</option>
                      {this.props.COptionLineaPais}
                    </select>
                  </span>

                </div>
              </div>
            </div>
          </div>
            <div className="field is-horizontal columns is-gapless">
              <div className="column">
                <div className="field-label"><label className="label">Source</label></div>
              </div>
              <div className="field-body column  is-three-quarters">
                <div className="field">
                  <div className="control">
                    <input className="input form-control" name="source" type="text"  placeholder="" />
                  </div>

                </div>
              </div>
            </div>

          </form>
        </ModalCard>}
      </div>
    )
  }
}

const mapStateToProps = (state, props /*, ownProps*/) => {
  console.log('mapStateToProps import2',state)
    return {
      currentTab: state.reducerTab.tab,
      importData: state.reducerData

    }
  }
export default connect(mapStateToProps, {import_current_tab, import_set_data })(ImportarStep2)